export const iconFontAwesomeFilesFolderClosed = (
	<i className="fa-solid fa-folder-closed"></i>
);
